import { useCallback } from 'react';
import { useGetMessageBusUpdates } from 'credit-memos-ui-lib/hooks/useGetMessageBusUpdates';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID, LINE_ITEM_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
const useCreditMemoEditor = (setCreditMemoEditorOpen, objectId) => {
  const {
    sendCreditMemoUpdatedMessage,
    updateCreditMemoAssociations
  } = useGetMessageBusUpdates(objectId);
  const handleCreditMemoEditorClose = useCallback(updatedCreditMemo => {
    setCreditMemoEditorOpen(false);
    if (updatedCreditMemo) {
      sendCreditMemoUpdatedMessage();
      updateCreditMemoAssociations(COMPANY_TYPE_ID);
      updateCreditMemoAssociations(LINE_ITEM_TYPE_ID);
      updateCreditMemoAssociations(CONTACT_TYPE_ID);
    }
  }, [setCreditMemoEditorOpen, sendCreditMemoUpdatedMessage, updateCreditMemoAssociations]);
  return {
    handleCreditMemoEditorClose
  };
};
export default useCreditMemoEditor;